module.exports = "<div class=\"panel\">\n\t<h2>Użytkownicy</h2>\n\n\t<data-table [columns]=\"columns\" [rows]=\"users\" [buttons]=\"actions\" [isLoading]=\"isLoading\"\n\t            [pager]=\"pager\" (tableChanged)=\"tableChanged($event)\"></data-table>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/app/shared/simple-crud/simple-crud.component.html
// module id = ../../../../../src/app/shared/simple-crud/simple-crud.component.html
// module chunks = 1